export const selectRouterPathname = (state) => state.router.getIn(['location', 'pathname']);

export const selectRouterQueryNotice = () => window.flash_notice;

export const selectRouterQuery = (state) => state.router.getIn(['location', 'query']);
